import { useContext, useRef, useEffect, useState } from "react";
import { AppContext } from "../Context";
import ParamFabric from "./ParamFabric";
import ParamCollar from "./ParamCollar";
import ParamCuff from "./ParamCuff";
import ParamMonogram from "./ParamMonogram";
import ParamPocket from "./ParamPocket";
import ParamContrast from "./ParamContrast";
import ParamTuxedo from "./ParamTuxedo";
import ParamPlacket from "./ParamPlacket";
import ParamStitch from "./ParamStitch";

function SubMenu() {
    const { state } = useContext(AppContext);
    const { dispatch } = useContext(AppContext);
    const [paramId, setParamId] = useState(null);
    const [visible, setVisible] = useState(true);
    const [pendingId, setPendingId] = useState(null);
    const submenu = useRef(null);

    function onClose() {
        submenu.current.style.display = "none";
        dispatch({ type: "SET_MENU", payload: null });
    }

    useEffect(() => {
        if (state.orientation == "portrait") {
            if (state.done) {
                dispatch({ type: "SET_DONE", payload: false });
                onClose();
            }
        }
    }, [state.done]);

    useEffect(() => {
        if (state.menu != null) {
            if (submenu.current.style.display == "flex") {
                setPendingId(state.menu);
                setVisible(false);
            } else {
                submenu.current.style.display = "flex";
                setVisible(true);
                setParamId(state.menu);
            }
        }
    }, [state.menu])

    useEffect(() => {
        dispatch({ type: "SET_MENU", payload: state.orientation == "landscape" ? "fabric" : null });
        submenu.current.style.display = state.orientation == "landscape" ? "flex" : "none";
    }, [])

    const handleTransitionEnd = (e) => {
        if (e.propertyName !== "opacity") return;
        if (!visible && pendingId) {
            setParamId(pendingId);
            setPendingId(null);
            setVisible(true);
        }
    };

    const renderContent = () => {
        switch (paramId) {
            case "fabric":
                return <ParamFabric />;
            case "collar":
                return <ParamCollar />;
            case "cuff":
                return <ParamCuff />;
            case "monogram":
                return <ParamMonogram />;
            case "pocket":
                return <ParamPocket />
            case "contrast":
                return <ParamContrast />
            case "tuxedo":
                return <ParamTuxedo />
            case "placket":
                return <ParamPlacket />
            case "stitch":
                return <ParamStitch />
            default:
                return null;
        }
    };

    return (
        <div ref={submenu} className="SubMenu">
            <div
                className={`fadeBox ${visible ? "show" : "hide"}`}
                onTransitionEnd={handleTransitionEnd}
            >
                {renderContent()}
            </div>

            <img
                onClick={onClose}
                style={{ display: state.orientation == "landscape" ? "none" : "block" }}
                className="btnCloseSubmenu"
                src={process.env.PUBLIC_URL + "/images/close.svg"}
                alt="close"
            />
        </div>
    );
}

export default SubMenu;
